import { IDichVuSelectRequest } from '../../models/request/dich-vu/dichVuRequests';
import { ISaleSetRegisterInsertMultipleRequest } from '../../models/request/dich-vu/saleSetRegisterRequests';
import { sf_saleset_register } from '../../models/response/dich-vu/sf_saleset_register';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_SALESET_REGISTER_PATH = "saleset-register";

class SaleSetRegisterApi extends BaseCRUDApi<sf_saleset_register> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	Select(request: IDichVuSelectRequest) {
		return apiClient.post(`${API_SALESET_REGISTER_PATH}/select`, request);
	}
	SelectHinhThucNopPhi(request: IDichVuSelectRequest) {
		return apiClient.post(`${API_SALESET_REGISTER_PATH}/select-hinhthuc-nopphi`, request);
	}
	InsertMultiple(request: ISaleSetRegisterInsertMultipleRequest) {
		return apiClient.post(`${API_SALESET_REGISTER_PATH}/insert-multiple`, request);
	}
}
export const saleSetRegisterApi = new SaleSetRegisterApi(API_SALESET_REGISTER_PATH);
